import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Input, Button } from 'components'
import travelImg from 'images/tmp_travel_image.png'
import styles from './index.module.css'

const TravelMain = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className="padding pb_50">
					<div className={styles["l-title"]}>김모니님 어디로 여행갈까요?</div>
					<p className="guide-title mt_20">국내 지역별 관광지 정보와 숙박시설부터<br />각종 축제와 행사, 음식점 정보까지 알려드려요!</p>

					<div className="form-group search-bar mt_30">
						<Input readOnly type="text" placeholder="키워드로 여행지를 찾아보세요!" id="" />
						<i className="icon icon_search" />
					</div>
				</div>
			</div>
			<div className="shadow">
				<div className="padding pb_50">
					<div className={styles["l-title"]}>어떤 여행 정보가 궁금한가요?</div>
					<div className={`${styles["travel-menu"]} mt_40 px_20`}>
						<div>
							<div>
								<i className={`${styles["icon_travel"]} ${styles["icon_travel_menu01"]} icon`} />
								<span>관광지</span>
							</div>
							<div>
								<i className={`${styles["icon_travel"]} ${styles["icon_travel_menu02"]} icon`} />
								<span>문화시설</span>
							</div>
							<div>
								<i className={`${styles["icon_travel"]} ${styles["icon_travel_menu03"]} icon`} />
								<span>숙박</span>
							</div>
							<div>
								<i className={`${styles["icon_travel"]} ${styles["icon_travel_menu04"]} icon`} />
								<span>여행코스</span>
							</div>
						</div>
						<div className="mt_30">
							<div>
								<i className={`${styles["icon_travel"]} ${styles["icon_travel_menu05"]} icon`} />
								<span>축제・행사</span>
							</div>
							<div>
								<i className={`${styles["icon_travel"]} ${styles["icon_travel_menu06"]} icon`} />
								<span>레포츠</span>
							</div>
							<div>
								<i className={`${styles["icon_travel"]} ${styles["icon_travel_menu07"]} icon`} />
								<span>쇼핑</span>
							</div>
							<div>
								<i className={`${styles["icon_travel"]} ${styles["icon_travel_menu08"]} icon`} />
								<span>음식</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="shadow">
				<div className="padding pb_50">
					<div className={styles["l-title"]}>어디로 여행 가고 싶나요?</div>

					{/* 지도 영역 */}
					<div className="mt_30" style={{ height: "38rem", background: "#f5f5f5" }}></div>
				</div>
			</div>
			<div className="padding">
				<div className={styles["l-title"]}>이런 여행코스는 어때요?</div>
				<div className={`${styles["travel-list"]} mt_40`}>
					<div>
						<div className="img-box" style={{ height: "20rem" }}>
							<img src={travelImg} alt="" />
						</div>
						<div className={styles["txt-area"]}>
							<div className={styles.title}>
								동해 바다를 굽어보는
								강릉 7번 국도 여행
							</div>
							<div className={`${styles.info} mt_10`}>
								<div>
									<i className="icon_life icon_life_place_white icon mr_5" />
									<span>총 거리 16km</span>
								</div>
								<div className="ml_10">
									<i className="icon_life icon_life_time_white icon mr_5" />
									<span>7시간 소요</span>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div className="img-box" style={{ height: "20rem" }}>
							<img src={travelImg} alt="" />
						</div>
						<div className={styles["txt-area"]}>
							<div className={styles.title}>
								동해 바다를 굽어보는
								강릉 7번 국도 여행
							</div>
							<div className={`${styles.info} mt_10`}>
								<div>
									<i className="icon_life icon_life_place_white icon mr_5" />
									<span>총 거리 16km</span>
								</div>
								<div className="ml_10">
									<i className="icon_life icon_life_time_white icon mr_5" />
									<span>7시간 소요</span>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div className="img-box" style={{ height: "20rem" }}>
							<img src={travelImg} alt="" />
						</div>
						<div className={styles["txt-area"]}>
							<div className={styles.title}>
								동해 바다를 굽어보는
								강릉 7번 국도 여행
							</div>
							<div className={`${styles.info} mt_10`}>
								<div>
									<i className="icon_life icon_life_place_white icon mr_5" />
									<span>총 거리 16km</span>
								</div>
								<div className="ml_10">
									<i className="icon_life icon_life_time_white icon mr_5" />
									<span>7시간 소요</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Button className="btn btn--big btn-more mt_40">+ 더보기</Button>
				<div className={`${styles["guide-bottom"]} mt_50`}>한국관광공사에서 받아오는 정보입니다.</div>
			</div>
		</div>
	)
}

export default TravelMain